import { DeviceType } from '@/utils/definitions';

export const isImageForDevice = async (
  src: string,
  device: DeviceType,
): Promise<boolean> =>
  new Promise((resolve) => {
    const img = new Image();

    img.onload = () => {
      const isPortrait = img.naturalHeight > img.naturalWidth;

      resolve(device === DeviceType.Mobile ? isPortrait : !isPortrait);
    };

    img.onerror = () => resolve(false);
    img.src = src;
  });

export const filterImagesByDevice = async (
  images: string[],
  device: DeviceType,
): Promise<string[]> => {
  if (!device) return images;
  const result = await Promise.all(
    images.map(async (src) => ({
      src,
      isVisible: await isImageForDevice(src, device),
    })),
  );

  return result.filter((image) => image.isVisible).map((image) => image.src);
};
